import React, { Component } from "react";
import { Grid, Row, Col, Button, FormGroup,
    ControlLabel,
    FormControl } from "react-bootstrap";
import { fetchEmployeeTypeRequest } from "../../../api/employeeType";
import moment from "moment";
import { getFriendlyRuleName } from "../../../helpers/functions/employeeType.js"

class EmployeeTypeDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            resource: {
                _id: null,
                employeeTypeName: null,
                factor: null,
                lateRuleArray: null,
                undertimeRuleArray: null,
                absentRuleArray: null,
                overtimeRuleArray: null,
                longevityRule: null,
                holidayRule: null,
                nightShiftRuleArray: null,
                mondaySchedule: {},
                tuesdaySchedule: {},
                wednesdaySchedule: {},
                thursdaySchedule: {},
                fridaySchedule: {},
                saturdaySchedule: {},
                sundaySchedule: {},
                createdAt: null,
                updatedAt: null
            }
        }
    }

    componentDidMount() {
        const { instanceId } = this.props;
        if(instanceId) {
            this.fetchEmployeeType(instanceId)
        }
    }

    fetchEmployeeType = (id) => {
        fetchEmployeeTypeRequest(id, result => this.setState({resource: result}), error => console.log(error))
    }

    render() {

        const { 
            _id, 
            employeeTypeName,
            factor,
            lateRuleArray,
            absentRuleArray,
            undertimeRuleArray,
            overtimeRuleArray,
            longevityRule,
            holidayRule,
            nightShiftRuleArray,
            mondaySchedule,
            tuesdaySchedule,
            wednesdaySchedule,
            thursdaySchedule,
            fridaySchedule,
            saturdaySchedule,
            sundaySchedule,
            createdAt, 
            updatedAt
          } = this.state.resource;

        return (
            <Grid fluid>
                <div className="form-header">
                    <h3 className="text-secondary font-weight-bold">
                        EmployeeType Instance Details
                    </h3>
                    <Button className="btn btn-primary top-btn" onClick={() => this.props.goToList('employee-type')}>Back to list</Button>
                </div>
                <Row>
                    <Col md={12}>
                        <div className="typo-line">
                            <div>
                            <p className="category">Instance ID</p>
                            {_id || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Employee Type</p>
                            {employeeTypeName || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Factor</p>
                            {factor || 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Late Rule</p>
                            {lateRuleArray && lateRuleArray.map((entry) => {
                                return (
                                    <p>
                                        Rule: {entry.rule.label}, 
                                        Effetive Start Date: {entry.effectiveDateStart || "N/A"},
                                        Effetive End Date: {entry.effectiveDateEnd || "N/A"}
                                    </p>
                                )
                            })}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Absent Rule</p>
                            {absentRuleArray && absentRuleArray.map((entry) => {
                                return (
                                    <p>
                                        Rule: {entry.rule.label}, 
                                        Effetive Start Date: {entry.effectiveDateStart || "N/A"},
                                        Effetive End Date: {entry.effectiveDateEnd || "N/A"}
                                    </p>
                                )
                            })}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Undertime Rule</p>
                            {undertimeRuleArray && undertimeRuleArray.map((entry) => {
                                return (
                                    <p>
                                        Rule: {entry.rule.label}, 
                                        Effetive Start Date: {entry.effectiveDateStart || "N/A"},
                                        Effetive End Date: {entry.effectiveDateEnd || "N/A"}
                                    </p>
                                )
                            })}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Overtime Rule</p>
                            {overtimeRuleArray && overtimeRuleArray.length
                                ? overtimeRuleArray.map((entry) => {
                                    return (
                                        <p>
                                            Rule: {entry.rule.label}, 
                                            Effetive Start Date: {entry.effectiveDateStart || "N/A"},
                                            Effetive End Date: {entry.effectiveDateEnd || "N/A"}
                                        </p>
                                    )
                                })
                                : <p>N/A</p>
                            }
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Night Shift Rule</p>
                            {nightShiftRuleArray && nightShiftRuleArray.length
                                ? nightShiftRuleArray.map((entry) => {
                                    return (
                                        <p>
                                            Rule: {entry.rule.label}, 
                                            Effetive Start Date: {entry.effectiveDateStart || "N/A"},
                                            Effetive End Date: {entry.effectiveDateEnd || "N/A"}
                                        </p>
                                    )
                                })
                                : <p>N/A</p>
                            }
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Longevity Rule</p>
                            {longevityRule ? getFriendlyRuleName('longevityRule', longevityRule) : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Holiday Rule</p>
                            {holidayRule ? getFriendlyRuleName('holidayRule', holidayRule) : 'N/A'}
                            </div>
                        </div>
                        
                        <div className="typo-line">
                            <div>
                            <p className="category">Created At</p>
                            {createdAt ? moment(createdAt).format('MMMM Do YYYY, h:mm:ss a') : 'N/A'}
                            </div>
                        </div>
                        <div className="typo-line">
                            <div>
                            <p className="category">Updated At</p>
                            {updatedAt ? moment(updatedAt).format('MMMM Do YYYY, h:mm:ss a') : 'N/A'}
                            </div>
                        </div>
                        <div className="form-section-wrapper">
                            <h3 className="title">Schedule</h3>
                            <Row
                                className="form-section"
                            >
                                <div className="col-md-12">
                                    <h6>
                                    Monday
                                    </h6>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Time In</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="timeIn"
                                        value={mondaySchedule.timeIn}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Lunch Start</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="lunchStart"
                                        value={mondaySchedule.lunchStart}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Lunch End</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="lunchEnd"
                                        value={mondaySchedule.lunchEnd}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Time Out</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="timeOut"
                                        value={mondaySchedule.timeOut}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                            </Row>
                            <Row
                                className="form-section"
                            >
                                <div className="col-md-12">
                                    <h6>
                                    Tuesday
                                    </h6>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Time In</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="timeIn"
                                        value={tuesdaySchedule.timeIn}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Lunch Start</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="lunchStart"
                                        value={tuesdaySchedule.lunchStart}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Lunch End</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="lunchEnd"
                                        value={tuesdaySchedule.lunchEnd}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Time Out</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="timeOut"
                                        value={tuesdaySchedule.timeOut}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                            </Row>
                            <Row
                                className="form-section"
                            >
                                <div className="col-md-12">
                                    <h6>
                                    Wednesday
                                    </h6>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Time In</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="timeIn"
                                        value={wednesdaySchedule.timeIn}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Lunch Start</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="lunchStart"
                                        value={wednesdaySchedule.lunchStart}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Lunch End</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="lunchEnd"
                                        value={wednesdaySchedule.lunchEnd}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Time Out</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="timeOut"
                                        value={wednesdaySchedule.timeOut}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                            </Row>
                            <Row
                                className="form-section"
                            >
                                <div className="col-md-12">
                                    <h6>
                                    Thursday
                                    </h6>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Time In</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="timeIn"
                                        value={thursdaySchedule.timeIn}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Lunch Start</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="lunchStart"
                                        value={thursdaySchedule.lunchStart}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Lunch End</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="lunchEnd"
                                        value={thursdaySchedule.lunchEnd}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Time Out</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="timeOut"
                                        value={thursdaySchedule.timeOut}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                            </Row>
                            <Row
                                className="form-section"
                            >
                                <div className="col-md-12">
                                    <h6>
                                    Friday
                                    </h6>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Time In</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="timeIn"
                                        value={fridaySchedule.timeIn}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Lunch Start</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="lunchStart"
                                        value={fridaySchedule.lunchStart}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Lunch End</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="lunchEnd"
                                        value={fridaySchedule.lunchEnd}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Time Out</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="timeOut"
                                        value={fridaySchedule.timeOut}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                            </Row>
                            <Row
                                className="form-section"
                            >
                                <div className="col-md-12">
                                    <h6>
                                    Saturday
                                    </h6>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Time In</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="timeIn"
                                        value={saturdaySchedule.timeIn}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Lunch Start</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="lunchStart"
                                        value={saturdaySchedule.lunchStart}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Lunch End</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="lunchEnd"
                                        value={saturdaySchedule.lunchEnd}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Time Out</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="timeOut"
                                        value={saturdaySchedule.timeOut}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                            </Row>
                            <Row
                                className="form-section"
                            >
                                <div className="col-md-12">
                                    <h6>
                                    Sunday
                                    </h6>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Time In</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="timeIn"
                                        value={sundaySchedule.timeIn}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Lunch Start</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="lunchStart"
                                        value={sundaySchedule.lunchStart}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Lunch End</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="lunchEnd"
                                        value={sundaySchedule.lunchEnd}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                                <div className="col-md-3">
                                    <FormGroup>
                                    <ControlLabel>Time Out</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="timeOut"
                                        value={sundaySchedule.timeOut}
                                        readOnly
                                        placeholder=""
                                    />
                                    </FormGroup>
                                </div>
                            </Row>
                        </div>
                        <Button className="btn btn-primary bottom-btn" onClick={() => this.props.goToEditForm('employeeType', _id)}>Edit</Button>
                    </Col>
                </Row>
            </Grid>
        );
    }
}

export default EmployeeTypeDetails;
